import { Link } from 'react-router-dom';
import { studio } from '@/mocks/projects';
import SectionShell from '@/components/feature/SectionShell';
import SectionHeader from '@/components/feature/SectionHeader';
import { RevealGroup } from '@/lib/motion/Reveal';
import { playRouteFade } from '@/lib/route-fade';

/** Home contact: compact CTA only — full inquiry lives on /contact. */
export default function ContactSection() {
  return (
    <SectionShell id="contact" labelledBy="contact-title">
      <SectionHeader index="07" name="Contact" titleId="contact-title" title="Tell me about the project." meta="Replies within two business days" className="!mb-0" />
      <RevealGroup className="mt-10 flex flex-col gap-8 md:mt-12 md:flex-row md:items-end md:justify-between">
        <div className="mo-item mo--copy text-[15px] leading-relaxed text-foreground-700">
          <p className="text-foreground-950">Campaigns, portraits and commercial commissions.</p>
          <p>{studio.location} · Available worldwide.</p>
        </div>
        <div className="mo-item mo--cta flex flex-col">
        <Link to="/contact" onClick={playRouteFade} className="mo-btn mo-btn--cta inline-flex items-center justify-center gap-2 bg-foreground-950 px-8 py-4 font-label text-[12px] font-medium uppercase tracking-[0.12em] text-background-50 hover:opacity-90 whitespace-nowrap cursor-pointer">
          <span className="mo-uline">Start an inquiry</span> <span aria-hidden="true" className="mo-arrow">→</span>
        </Link>
        </div>
      </RevealGroup>
    </SectionShell>
  );
}